/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Navbar - Adjust on scroll (desktop)
const navbarWrapper = document.querySelector('#shopify-section-navbar.fixed-top')
const navbar = navbarWrapper.querySelector('#navbar')

if (navbar) {
    window.addEventListener('scroll', () => {
        if (window.scrollY > navbar.getBoundingClientRect().top) {
            navbar.classList.add('bg-white', 'shadow-sm')
        } else {
            navbar.classList.remove('bg-white', 'shadow-sm')
        }
    })
}

// Carousel - Go to corresponding slide on editor
document.addEventListener('shopify:block:select', (e) => {
    const carouselEl = e.target.closest('.carousel')

    if (carouselEl) {
        const selectedSlide = e.target.dataset.index
        bootstrap.Carousel.getOrCreateInstance(carouselEl, { interval: false }).to(selectedSlide)
    }
})

// Parallax with text
const initParallaxWithText = () => {
    document.querySelectorAll('.parallax-with-text.jarallax:not(.init)').forEach(($el) => {
        $el.classList.add('init')

        jarallax($el, {
            speed: Number($el.dataset.parallaxSpeed)
        })
    })
}
initParallaxWithText()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.parallax-with-text.jarallax')) {
        initParallaxWithText()
    }
})

/*
    Product Sticky ATC  - Handle Visibility
*/
const productStickyATCVisibility = () => {
    const $stickyATC = document.querySelector('#product-sticky-atc')
    const $atcForm = document.querySelector('#product-page form[action="/cart/add"]')

    if ($stickyATC && $atcForm) {
        const threshold = $atcForm.getBoundingClientRect().bottom
        const $htmlEl = document.documentElement
        const stickyATCheight = $stickyATC.clientHeight

        window.addEventListener('scroll', () => {
            if (window.scrollY > threshold) {
                $stickyATC.classList.add('show')
                $htmlEl.style.paddingBottom = `${stickyATCheight}px`
            } else {
                $stickyATC.classList.remove('show')
                $htmlEl.style.paddingBottom = 0
            }
        })
    }
}
productStickyATCVisibility()

/*
    Product Sticky ATC  - Handle variant change
*/
const productStickyATCVariantChange = () => {
    const $variantSelecetor = document.querySelector('#product-sticky-atc select[name="id"]')

    $variantSelecetor?.addEventListener('change', (e) => {
        const variantImage = $variantSelecetor.options[$variantSelecetor.selectedIndex].dataset.variantImg

        if (variantImage) {
            const $img = $variantSelecetor.closest('#product-sticky-atc').querySelector('.product-img')
            $img.setAttribute('src', variantImage)
        }
    })
}
productStickyATCVariantChange()

/*
    Recommended Products
*/
const initRecommendedProducts = () => {
    const recommendedProducts = document.querySelector('.recommended-products')
    if (recommendedProducts) {
        const {
            sectionId, baseUrl, productId, limit
        } = recommendedProducts.dataset

        const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}`

        fetch(url)
            .then((response) => response.text())
            .then((data) => {
                recommendedProducts.closest('.shopify-section').outerHTML = data

                const $smartShypItem = document.querySelector('.recommended-products [data-is-smartshyp="true"]')

                if ($smartShypItem) {
                    $smartShypItem.remove()
                } else {
                    document.querySelector('.recommended-products [data-is-smartshyp]').remove()
                }
            })
    }
}
initRecommendedProducts()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.recommended-products')) {
        initRecommendedProducts()
    }
})

// Featured Products - Init Splide Slider
const initFeaturedProductsSliders = () => {
    document.querySelectorAll('.splide-products:not(.init)')
        .forEach((el) => {
            const splide = new Splide(el, {
                arrows: el.dataset.arrows === 'true',
                pagination: el.dataset.pagination === 'true',
                easing: el.dataset.easing,
                speed: Number(el.dataset.speed),
                autoplay: el.dataset.autoplay === 'true',
                interval: Number(el.dataset.interval),
                perMove: Number(el.dataset.perMove),
                rewind: true,
                mediaQuery: 'min',
                perPage: Number(el.dataset.breakpointXs),
                drag: el.dataset.freeScroll === 'true' ? 'free' : true,
                padding: '12%',
                breakpoints: {
                    576: { perPage: Number(el.dataset.breakpointSm), padding: 0 },
                    768: { perPage: Number(el.dataset.breakpointMd), padding: 0 },
                    992: { perPage: Number(el.dataset.breakpointLg), padding: 0 },
                    1200: { perPage: Number(el.dataset.breakpointXl), padding: 0 },
                    1400: { perPage: Number(el.dataset.breakpointXxl), padding: 0 }
                }
            })

            splide.mount()
            el.classList.add('init')
        })
}
initFeaturedProductsSliders()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.featured-products')) {
        initFeaturedProductsSliders()
    }
})

// Blog Posts - Init Splide Slider
const initBlogPostsSliders = () => {
    document.querySelectorAll('.blog-posts .splide:not(.init)')
        .forEach((el) => {
            const splide = new Splide(el, {
                arrows: el.dataset.arrows === 'true',
                pagination: el.dataset.pagination === 'true',
                easing: el.dataset.easing,
                speed: Number(el.dataset.speed),
                autoplay: el.dataset.autoplay === 'true',
                interval: Number(el.dataset.interval),
                perMove: Number(el.dataset.perMove),
                rewind: true,
                mediaQuery: 'min',
                perPage: Number(el.dataset.breakpointXs),
                drag: el.dataset.freeScroll === 'true' ? 'free' : true,
                padding: '12%',
                breakpoints: {
                    576: { perPage: Number(el.dataset.breakpointSm), padding: 0 },
                    768: { perPage: Number(el.dataset.breakpointMd), padding: 0 },
                    992: { perPage: Number(el.dataset.breakpointLg), padding: 0 },
                    1200: { perPage: Number(el.dataset.breakpointXl), padding: 0 },
                    1400: { perPage: Number(el.dataset.breakpointXxl), padding: 0 }
                }
            })

            splide.mount()
            el.classList.add('init')
        })
}
initBlogPostsSliders()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.blog-posts')) {
        initBlogPostsSliders()
    }
})

// How it works - mobile
const initHowItWorksMobile = () => {
    document.querySelectorAll('.how-it-works-mobile .splide:not(.init)')
        .forEach((el) => {
            const splide = new Splide(el, {
                arrows: el.dataset.arrows === 'true',
                pagination: el.dataset.pagination === 'true',
                easing: el.dataset.easing,
                speed: Number(el.dataset.speed),
                autoplay: el.dataset.autoplay === 'true',
                interval: Number(el.dataset.interval),
                perMove: Number(el.dataset.perMove),
                type: el.dataset.infinite === 'true' ? 'loop' : 'slide',
                rewind: el.dataset.infinite === 'true' ? false : true,
                mediaQuery: 'min',
                perPage: Number(el.dataset.breakpointXs),
                drag: el.dataset.freeScroll === 'true' ? 'free' : true,
                // Enhanced touch/swipe settings for infinite scroll
                wheel: el.dataset.infinite === 'true',
                wheelSleep: el.dataset.infinite === 'true' ? 100 : 0,
                releaseWheel: el.dataset.infinite === 'true',
                swipeDistanceThreshold: 30,
                flickVelocityThreshold: 0.2,
                trimSpace: false,
                padding: '12%',
                breakpoints: {
                    576: { perPage: Number(el.dataset.breakpointSm), padding: 0 },
                    768: { perPage: Number(el.dataset.breakpointMd), padding: 0 },
                    992: { perPage: Number(el.dataset.breakpointLg), padding: 0 },
                    1200: { perPage: Number(el.dataset.breakpointXl), padding: 0 },
                    1400: { perPage: Number(el.dataset.breakpointXxl), padding: 0 }
                }
            })

            const fixArrowsPosition = () => {
                el.querySelectorAll('.splide__arrow').forEach((arrow) => {
                    arrow.style.top = el.querySelector('img').clientHeight / 2 + 'px'
                    arrow.style.transform = 'translateY(-50%)'
                })
            }

            splide.on('updated', () => {
                fixArrowsPosition()
            })

            splide.mount()
            el.classList.add('init')

            setTimeout(() => {
                fixArrowsPosition()
            }, 500)
        })
}
initHowItWorksMobile()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.how-it-works-mobile')) {
        initHowItWorksMobile()
    }
})

// How it works - desktop
document.querySelectorAll('.how-it-works-desktop').forEach((section) => {
    const navbarHeight = document.querySelector('#shopify-section-navbar.fixed-top')?.clientHeight || 0
    const carousel = section.querySelector('.carousel')

    carousel.style.top = (window.innerHeight + navbarHeight - carousel.clientHeight) / 2 + 'px'

    const sectionList = section.querySelector('.how-it-works-desktop-content')
    const bsCarousel = bootstrap.Carousel.getOrCreateInstance(carousel)

    window.addEventListener('scroll', () => {
        const value = sectionList.getBoundingClientRect().top

        if (value < -700) {
            bsCarousel.to(2)
            sectionList.querySelector('li:nth-child(1)').style.opacity = '.25'
            sectionList.querySelector('li:nth-child(2)').style.opacity = '.25'
            sectionList.querySelector('li:nth-child(3)').style.opacity = '1'
        } else if (value < -150) {
            bsCarousel.to(1)
            sectionList.querySelector('li:nth-child(1)').style.opacity = '.25'
            sectionList.querySelector('li:nth-child(2)').style.opacity = '1'
            sectionList.querySelector('li:nth-child(3)').style.opacity = '.25'
        } else {
            bsCarousel.to(0)
            sectionList.querySelector('li:nth-child(1)').style.opacity = '1'
            sectionList.querySelector('li:nth-child(2)').style.opacity = '.25'
            sectionList.querySelector('li:nth-child(3)').style.opacity = '.25'
        }
    })
})

// Featured Reviews
const initFeaturedReviews = () => {
    document.querySelectorAll('.featured-reviews .splide:not(.init)')
        .forEach((el) => {
            const splide = new Splide(el, {
                arrows: el.dataset.arrows === 'true',
                pagination: el.dataset.pagination === 'true',
                easing: el.dataset.easing,
                speed: Number(el.dataset.speed),
                autoplay: el.dataset.autoplay === 'true',
                interval: Number(el.dataset.interval),
                perMove: Number(el.dataset.perMove),
                rewind: true,
                mediaQuery: 'min',
                perPage: Number(el.dataset.breakpointXs),
                drag: el.dataset.freeScroll === 'true' ? 'free' : true,
                padding: '10%',
                breakpoints: {
                    576: { perPage: Number(el.dataset.breakpointSm), padding: 0 },
                    768: { perPage: Number(el.dataset.breakpointMd), padding: 0 },
                    992: { perPage: Number(el.dataset.breakpointLg), padding: 0 },
                    1200: { perPage: Number(el.dataset.breakpointXl), padding: 0 },
                    1400: { perPage: Number(el.dataset.breakpointXxl), padding: 0 }
                }
            })

            const fixArrowsPosition = () => {
                el.querySelectorAll('.splide__arrow').forEach((arrow) => {
                    arrow.style.top = el.querySelector('.splide__slide__inner').clientHeight / 2 + 'px'
                    arrow.style.transform = 'translateY(-50%)'
                })
            }

            splide.on('updated', () => {
                fixArrowsPosition()
            })

            splide.mount()
            el.classList.add('init')

            setTimeout(() => {
                fixArrowsPosition()
            }, 500)
        })
}
initFeaturedReviews()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.featured-reviews')) {
        initFeaturedReviews()
    }
});

/*
    Our mission content
*/
(() => {
    const boat = document.querySelector('.our-mission-content-line-with-boat > div')

    if (boat) {
        window.addEventListener('scroll', () => {
            if (window.matchMedia('(min-width: 576px)').matches) {
                boat.style.left = 250 + window.scrollY / 2 + 'px'
            } else {
                boat.style.left = 0 + window.scrollY / 3 + 'px'
            }
        })
    }

    const counter = document.querySelector('[data-animate-custom-counter]')

    if (counter) {
        // assumes integer values for start and end

        const range = Number(counter.dataset.endValue) - Number(counter.dataset.startValue)

        console.log(Number(counter.dataset.duration))

        // no timer shorter than 50ms (not really visible any way)
        const minTimer = 50

        // calc step time to show all interediate values
        let stepTime = Math.abs(Math.floor(Number(counter.dataset.duration) / range))

        // never go below minTimer
        stepTime = Math.max(stepTime, minTimer)

        // get current time and calculate desired end time
        const startTime = new Date().getTime()
        const endTime = startTime + Number(counter.dataset.duration)
        let timer = 0

        const run = () => {
            const now = new Date().getTime()
            const remaining = Math.max((endTime - now) / Number(counter.dataset.duration), 0)
            const value = Math.round(Number(counter.dataset.endValue) - (remaining * range))
            counter.innerHTML = value

            if (value === Number(counter.dataset.endValue)) {
                clearInterval(timer)
            }
        }

        timer = setInterval(run, stepTime)
        run()
    }
})()
